import React from "react";
import * as Yup from "yup";

import {Field} from "formik";
import InputNumber from "./InputNumber.component";
import BaseSwitch from "../../../../../utils/forms/components/BaseSwitch.component";
import BaseBetJackpotArray
    from "../../../../../utils/forms/components/BaseBetJackpotArray.component";

export const LEVELS_NAMES = {
    0: "Mega",
    1: "Grand",
    2: "Major",
    3: "Minor",
    4: "Mini"
};

export const prizeFieldsValidation = ({progType, prizes, proportion_type, prize_type, coins}) => {
    let validations = {};

    /*
    progType
    0: "Levels",
    1: "Multipots",
    2: "EasyLink",
    3: "SAP",
    4: "Fractionated",
    7: "Reel Strike",
    8: "Jumbo Link"
    9: "LuckyToken"
     */

    prizes.map((prize, index) => {
        const isLast = index == prize.length - 1;
        validations[`${prize}_contribution`] = Yup.number()
            .required("Field is required.")
            .max(5, `Must be <= than 5`)
            .min(0.01, `Must be >= than 0.01`); //contribution

        validations[`${prize}_increment_sound_value`] = Yup.number()
            .required("Field is required.")
            .min(0, "Value must be >= 0."); //increment_sound_value

        if ((progType == 7 && (index == 3 || index == 4)) || index == 0) {
            validations[`${prize}_initial_value`] = Yup.number() //initial_value
                .required("Field is required.")
                .max(42949672.95, `Must be <= than 42949672.95`)
                .min(0, "Value must be >= 0.");
        } else {
            validations[`${prize}_initial_value`] = Yup.number() //initial_value
                .required("Field is required.")
                .min(0, "Value must be >= 0.")
                .max(42949672.95, `Must be <= than 42949672.95`)
                .when(`${prizes[index - 1]}_max_value`, (value, schema) => {
                    return value
                        ? schema.min(
                            value,
                            `Must be >= than ${
                                LEVELS_NAMES[prizes[index - 1]]
                            } Prize Max. Value.`
                        )
                        : schema;
                });
        }

        validations[`${prize}_max_value`] = Yup.number() //max_value
            .required("Field is required.")
            .min(0, "Value must be >= 0.")
            .max(42949672.95, `Must be <= than 42949672.95`)
            .when(`${prize}_initial_value`, (value, schema) => {
                return value
                    ? schema.min(value, `Must be >= than Initial Value.`)
                    : schema;
            });

        if (progType == 2 || progType == 9) {
            validations[`${prize}_min_game_mode`] = Yup.number()
                .required("Field is required.")
                .integer("Must be an integer")
                .min(0, "Value must be >= 0.");
        }
        if (((progType == "1" && prize_type == "child") || progType == "2" || progType == "9") && proportion_type == "proportional") {
            validations[`${prize}_max_proportional_total_bet`] = Yup.number()
                .required("Field is required.")
                .integer("Must be an integer")
                .min(1, "Value must be >= 1.");
        }

        if (progType == 1 && prize_type == "parent" && proportion_type == "fractionated") {
            let fieldsValidations = {}
            coins.map((coin) => fieldsValidations[coin.value] = Yup.number()
                /*
                .test(
                    "maxDigitsAfterDecimal",
                    `Field for ${coin.label} must have 2 digits after decimal or less`,
                    (number) => number && Number.isInteger(number * (10 ** 2))
                )
                 */
                .required(`Field for ${coin.label} is required. `)
                .min(0, `Field for ${coin.label} must be ≥ than 0`)
                .max(100, `Field for ${coin.label} must be ≤ than 100`)
            )
            validations[`${prize}_fractionated_jackpot_list`] = Yup.array(
                Yup.object(fieldsValidations)
            ).required("Field is required.");
        }

        if (progType == 7 && prize_type == "child" && [4, 3, 2].includes(prize)) {
            let fieldsValidations = {}
            coins.map((coin) => fieldsValidations[coin.value] = Yup.number()
                .required(`Field for ${coin.label} is required. `)
                .min(0, `Field for ${coin.label} must be ≥ than 0`)
                .max(100, `Field for ${coin.label} must be ≤ than 100`)
            )
            validations[`${prize}_fractionated_jackpot_list`] = Yup.array(
                Yup.object(fieldsValidations)
            ).required("Field is required.");

            validations[`${prize}_contribution`] = Yup.number()
                .required("Field is required.")
                .max(5, `Must be <= than 5`)
                .min(0, `Must be >= than 0`); //contribution
        }

        /*if (proportion_type == "normal") {
            validations[`${prize}_min_bet`] = Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."); //min_bet
        } else if (proportion_type == "proportional") {
            validations[`${prize}_max_bet`] = Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."); //max_bet
        }*/
    });

    return Yup.object().shape(validations);
};

/*const validationSchema = Yup.object().shape({
    password: Yup.string().required("Current Password is required"),
    new_password: Yup.string()
        .required("New Password is required")
        .matches(LOWER_CASE_REGEX, "Password must contain lower case character")
        .matches(UPPER_CASE_REGEX, "Password must contain upper case character")
        .matches(DIGIT_REGEX, "Password must contain digit")
        .matches(SYMBOL_REGEX, "Password must symbol (@$%*?&)")
        .min(MIN_PASS_LENGTH, `MIN_LENGTH{${MIN_PASS_LENGTH}}`),
    confirm_password: Yup.string()
        .required("Password confirmation is required")
        //@ts-ignore
        .equalTo(Yup.ref("new_password"))
});*/

export const PrizeFieldsForm = ({progType, prizes, proportion_type, prize_type, coins}) => {
    /*
    progType
    0: "Levels",
    1: "Multipots",
    2: "EasyLink",
    3: "SAP",
    4: "Fractionated",
    7: "Reel Strike",
    8: "Jumbo Link"
    9: "LuckyToken"
     */
    return (
        <React.Fragment>
            {prizes.map(prize => {
                return (
                    <div className="prize-panel" key={prize}>
                        <div className="prize-panel-header">
                            {LEVELS_NAMES[prize]}
                        </div>
                        <div className="prize-panel-body row">
                            <div className="col-4 percentage">
                                <div>
                                    <div className="label-tooltip">
                                        <label className="label">
                                            Contribution
                                        </label>
                                    </div>
                                    <div className="input-group">
                                        <Field
                                            className="form-input "
                                            name={`${prize}_contribution`}
                                            placeholder="Contribution"
                                            component={InputNumber}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="input-group col-4">
                                <div className="label-tooltip">
                                    <label className="label">
                                        Increment Sound Value
                                    </label>
                                </div>
                                <Field
                                    className="form-input"
                                    name={`${prize}_increment_sound_value`}
                                    placeholder="Increment Sound Value"
                                    component={InputNumber}
                                />
                            </div>
                            <div className="input-group col-4">
                                <div className="label-tooltip">
                                    <label className="label">
                                        Initial Value
                                    </label>
                                </div>
                                <Field
                                    className="form-input"
                                    name={`${prize}_initial_value`}
                                    placeholder="Initial Value"
                                    component={InputNumber}
                                />
                            </div>
                            {/*proportion_type == "proportional" && (
                                <div className="input-group col-4">
                                    <div className="label-tooltip">
                                        <label className="label">
                                            Max. Bet
                                        </label>
                                    </div>
                                    <Field
                                        className="form-input"
                                        name={`${prize}_max_bet`}
                                        placeholder="Max. Bet"
                                        component={InputNumber}
                                    />
                                </div>
                            )*/}
                            {/*proportion_type == "normal" && (
                                <div className="input-group col-4">
                                    <div className="label-tooltip">
                                        <label className="label">
                                            Min. Bet
                                        </label>
                                    </div>
                                    <Field
                                        className="form-input"
                                        name={`${prize}_min_bet`}
                                        placeholder="Min. Bet"
                                        component={InputNumber}
                                    />
                                </div>
                            )*/}
                            <div className="input-group col-4">
                                <div className="label-tooltip">
                                    <label className="label">Max. Value</label>
                                </div>
                                <Field
                                    className="form-input"
                                    name={`${prize}_max_value`}
                                    placeholder="Max. Value"
                                    component={InputNumber}
                                />
                            </div>
                            {progType == "3" && (
                                <div className="input-group col-4">
                                    <div className="label-tooltip">
                                        <label className="label">
                                            Individual pot
                                        </label>
                                    </div>
                                    <Field
                                        className="form-input"
                                        name={`${prize}_individual_pot`}
                                        placeholder="Individual pot"
                                        component={BaseSwitch}
                                    />
                                </div>
                            )}
                            {(progType == "2" || progType == "9") && (
                                <div className="input-group col-4">
                                    <div className="label-tooltip">
                                        <label className="label">Min. Game Mode</label>
                                    </div>
                                    <Field
                                        className="form-input"
                                        name={`${prize}_min_game_mode`}
                                        placeholder="Min. Game Mode"
                                        component={InputNumber}
                                    />
                                </div>
                            )}
                            {(((progType == "1" && prize_type == "child") || progType == "2" || progType == "8" || progType == "9") && proportion_type == "proportional") && (
                                <div className="input-group col-4">
                                    <div className="label-tooltip">
                                        <label className="label">Max. Proportional Total Bet</label>
                                    </div>
                                    <Field
                                        className="form-input"
                                        name={`${prize}_max_proportional_total_bet`}
                                        placeholder="Max. Proportional Total Bet"
                                        component={InputNumber}
                                    />
                                </div>
                            )}
                            {progType == "1" && prize_type == "parent" && proportion_type == "fractionated" && (
                                <div className="input-group prize-input col-12">
                                    <div className="label-tooltip">
                                        <label className="label">Fractionated Jackpot List</label>
                                    </div>
                                    <Field
                                        className="form-input prize-input"
                                        style={{padding: 0}}
                                        name={`${prize}_fractionated_jackpot_list`}
                                        placeholder={`${prize}_fractionated_jackpot_list`}
                                        items={coins}
                                        component={BaseBetJackpotArray}
                                    />

                                </div>
                            )}
                            {progType == "7" && prize_type == "child" && [4, 3, 2].includes(prize) && (
                                <div className="input-group col-12">
                                    <div className="label-tooltip">
                                        <label className="label">Fractionated Jackpot List</label>
                                    </div>
                                    <Field
                                        className="form-input prize-input"
                                        name={`${prize}_fractionated_jackpot_list`}
                                        placeholder={`${prize}_fractionated_jackpot_list`}
                                        items={coins}
                                        component={BaseBetJackpotArray}
                                    />

                                </div>
                            )}
                            {(progType == "2" || progType == "9") && (
                                <div className="input-group col-4">
                                    <div className="label-tooltip">
                                        <label className="label">
                                            Individual pot
                                        </label>
                                    </div>
                                    <Field
                                        className="form-input"
                                        name={`${prize}_individual_pot`}
                                        placeholder="Individual pot"
                                        component={BaseSwitch}
                                    />
                                </div>
                            )}
                            {progType == "7" && prize_type == "child" && [0, 1].includes(prize) && (
                                <div className="input-group col-4">
                                    <div className="label-tooltip">
                                        <label className="label">
                                            Individual pot
                                        </label>
                                    </div>
                                    <Field
                                        className="form-input"
                                        name={`${prize}_individual_pot`}
                                        placeholder="Individual pot"
                                        component={BaseSwitch}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </React.Fragment>
    );
};
